import React from "react";
import IconHeading from "../../../Icons/IconHeading";
import moneyFormat from "../../MoneyFormat/moneyFormat";
import {OUTWARD} from "../../consts/bookingConsts";
import Loading from "../../Loader/Loading";

const TripSelector = (props) => {

  const {
    type,
    options,
    selection,
    onSelect,
    loader
  } = props;

  return <>
    <div className="booking__section booking__transfer__section">
      <div className="booking__transfer">
        <div className="booking__title">
          <div className="booking__headIcon">
            <IconHeading />
          </div>
          <h3>{type === OUTWARD ? 'Select Transfer' : 'Select Return Transfer'}</h3>
        </div>
      </div>
      <div className="booking__transfer__options">
        {options.map((option, index) => {
          const selected = selection
            && selection.timeId === option.time_id
            && selection.activity === option.activity;
          return <div
            key={index}
            className={`booking__transfer__option ${selected ? 'booking__transfer--selected' : ''}`}>
            <div className="booking__transfer__option__wrap">
              <div className="booking__transfer__time">
                <p className="h5">
                  {!!option.name && <>{option.name}</>}
                  {!option.name && <>Departing {option.start_name} by {option.start_time}<br />
                  Arriving at {option.dropoff_name} by {option.dropoff_time}</>}
                </p>
              </div>
              <div className="booking__transfer__right">
                {/*<div className="booking__transfer__price">*/}
                {/*  <p className="h4">{moneyFormat(option.price)}</p>*/}
                {/*</div>*/}
                <div className="booking__transfer__action">
                  <button
                    type={'button'}
                    disabled={option.locked}
                    onClick={(e) => {
                      onSelect({
                        timeId: option.time_id,
                        activity: option.activity,
                        extras: [...option.extras]
                      }, option)
                    }}
                    className={`btn ${option.locked ? 'btn--disabled': ''} ${selected ? 'btn--selected': 'btn--hollow'}`}>
                    {option.locked ? 'Closed' : null}
                    {loader === option.activity ? <Loading /> : null}
                    {loader !== option.activity && !option.locked
                      ? (selected ? 'Selected' : 'Select') : null}
                  </button>
                </div>
              </div>
            </div>
          </div>
        })}
      </div>
    </div>
  </>
}

export default TripSelector;
